export const Routes = {
  PublicHome: { path: "/" },
  PublicAbout: { path: "/about" },
  AuthLogin: { path: "/auth/login" },
  Forbidden: { path: "/forbidden" },

  DashboardIndex: { path: "/dashboard" },
  DashboardUsers: { path: "/dashboard/users" },
  DashboardUserStatistic: { path: "/dashboard/users-statistic" },
  DashboardUserPosts: { path: "/dashboard/users-statistic/:userId" },
};
